export const Creators = {
    activateCoords: (option) => ({
        type: option
    })
}

